import {IMAGE_DEFAULT_FORMATS} from "../../../../../core/app/consts";
import {AssetsRequestParams} from "../../../../../infrastructure/models/params/assets-request-params";

export class ProhibitionImageRequestParams extends AssetsRequestParams {
  constructor(width: Number, height: Number) {
    super(width, height);

    this.resourceName = `${this.resourceName}/DisclaimerByLangID/Autoprohibicion`;
    this.version = 3;
    this.ratio = 3;
  }

  get defaultFormat(): String {
    return IMAGE_DEFAULT_FORMATS.SVG;
  }
}
